class CbnMobileNav extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.dialog = this.querySelector('dialog');
    this.opener = this.querySelector('[data-cbn-open]');
    this.scroller = this.querySelector('.cbn-nav__scroll');
    this.titleElement = this.querySelector('[data-cbn-title]');
    this.back = this.querySelector('[data-cbn-back]');
    this.addEventListener('click', this.onClick, { signal });
    this.dialog.addEventListener('close', this.onClose, { signal });
    window.addEventListener('pagehide', () => this.dialog.close(), { signal });
    this.opener.setAttribute('aria-expanded', 'false');
  }
  disconnectedCallback() {
    this.dialog?.close();
    this.restoreScroll();
    this.controller?.abort();
  }
  onClick = event => {
    const target = event.target.closest('a, button, dialog');
    if (!target) return;
    if (target.hasAttribute('data-cbn-open')) {
      event.preventDefault();
      this.overflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
      this.opener.setAttribute('aria-expanded', 'true');
    } else if (target.hasAttribute('data-cbn-close') || target === this.dialog) {
      if (target === this.dialog) {
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX >= box.left && event.clientX <= box.right && event.clientY >= box.top && event.clientY <= box.bottom) return;
      }
      this.dialog.close();
    } else if (target.hasAttribute('data-cbn-panel')) {
      this.returnTo = target;
      this.mainScroll = this.scroller.scrollTop;
      this.showScreen(target.dataset.cbnPanel);
      this.titleElement.textContent = target.textContent.trim();
      this.back.focus({ preventScroll:true });
    } else if (target.hasAttribute('data-cbn-back')) {
      this.showScreen('main');
      this.scroller.scrollTop = this.mainScroll || 0;
      this.returnTo?.focus({ preventScroll:true });
    }
  };
  showScreen(name) {
    let screen = this.querySelector(`[data-cbn-screen="${name}"]`);
    if (!screen) {
      const template = this.querySelector(`template[data-cbn-template="${name}"]`);
      if (!template) return;
      this.scroller.append(template.content.cloneNode(true));
      template.remove();
    }
    for (const item of this.querySelectorAll('[data-cbn-screen]')) item.hidden = item.dataset.cbnScreen !== name;
    for (const button of this.querySelectorAll('[data-cbn-panel]')) button.setAttribute('aria-expanded', String(button.dataset.cbnPanel === name));
    this.back.hidden = name === 'main';
    if (name === 'main') this.titleElement.textContent = this.titleElement.dataset.mainTitle;
    this.scroller.scrollTop = 0;
  }
  restoreScroll() {
    if (this.overflow === undefined) return;
    document.documentElement.style.overflow = this.overflow;
    this.overflow = undefined;
  }
  onClose = () => {
    this.restoreScroll();
    this.showScreen('main');
    this.opener.setAttribute('aria-expanded', 'false');
    if(this.isConnected) this.opener.focus({ preventScroll:true });
  };
}
if (!customElements.get('cbn-mobile-nav')) customElements.define('cbn-mobile-nav', CbnMobileNav);
